import React from 'react';
import FormLabel from '@material-ui/core/FormLabel'
import HorarioUtilizacao from './HorarioUtilizacao';

const HorarioGroup = ({data, handleInputTime, name}) => (
  <div>
      {<FormLabel component="legend">Horário de utilização</FormLabel>}
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent:"space-between", padding:"0px 0 17px 0" }}>
        {data.map((item, index) =>
          <HorarioUtilizacao
            item={item}
            name={name}
            handleInputTime={handleInputTime}
            key={index}
          />
        )}
      </div>
  </div>
);

export default HorarioGroup;
